<template>
  <form
    class="simple-update-form"
    @submit.prevent="submitForm"
  >
    <div class="row top-xs wada-bottom-space">
      <div class="col-xs-12 col-md-4 col-lg-3">
        <BaseFormField label="Status">
          <BaseSelect
            label="name"
            :placeholder="form.deleted | IsDeleted"
            @select="updateDeleted"
            :options="[{value: true, name: 'Slettet'}, {value: false, name: 'Aktivt'}]"
            :disabled="loading"
          />
        </BaseFormField>
      </div>
      <div class="col-xs-12 col-md-8 col-lg-9">
        <BaseInput
          label="Navn"
          v-model="form.name"
        />
      </div>
    </div>
    <div class="row wada-bottom-space">
      <div class="col-xs-12">
        <BaseInput
          label="Link"
          placeholder="https://example.com"
          v-model.trim="form.link"
        />
      </div>
    </div>
    <div class="row end-xs">
      <div class="col-xs-4">
        <BaseButton
          full
          label="Gem ændringer"
          :disabled="loading || $v.$invalid"
        />
      </div>
    </div>
    <div
      class="simple-update-form__loading"
      v-if="loading"
    >
      <BaseSpinner
        height="40px"
        width="40px"
      />
    </div>
  </form>
</template>

<script>
import { required, url } from 'vuelidate/lib/validators';
import BaseInput from '../../BaseInput.vue';
import BaseSelect from '../../BaseSelect.vue';
import BaseFormField from '../../BaseFormField.vue';
import BaseSpinner from '../../BaseSpinner.vue';
import BaseButton from '../../BaseButton.vue';
import WADAClassificationService from '../../../services/WADAClassificationService';
import IsDeleted from '../../../filters/IsDeleted';


export default {
    name: 'UpdateWADAClassificationForm',
    components: {
        BaseButton, BaseSpinner, BaseFormField, BaseSelect, BaseInput,
    },
    filters: { IsDeleted },
    props: {
        form: { type: Object, required: true },
    },
    data() {
        return {
            loading: false,
        };
    },
    validations: {
        form: {
            name: { required },
            link: { required, url },
        },
    },
    methods: {
        updateDeleted(e) {
            this.form.deleted = e.value;
        },
        async submitForm() {
            this.$v.$touch();

            if (this.$v.$invalid) {
                this.$snotify.error('Navn eller link er ikke udfyldt korrekt.');
                return;
            }

            try {
                this.loading = true;
                const payload = await WADAClassificationService.update(this.form);

                this.$snotify.success(`${payload.name} er opdateret`);
                this.loading = false;
            } catch (error) {
                this.loading = false;
            }
        },
    },
};
</script>

<style lang="scss" scoped>
.simple-update-form {
    margin-top: 20px;
    background-color: $white2;
    padding: 10px;
    border-radius: 5px;
    position: relative;

    &__loading {
        position: absolute;
        top: 0;
        left: 0;
        display: flex;
        justify-content: center;
        align-items: center;
        width: 100%;
        height: 100%;
    }
}
.wada-bottom-space {
    margin-bottom: 20px;
}
</style>
